module.exports = __webpack_public_path__ + "img/frame-mb.b5562155.webp";